
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/smart",
      function () {
        return require("private-next-pages/smart/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/smart"])
      });
    }
  